const serverEnv = (environmentKey: string) => {
  if (!environmentKey) {
    console.error('[Package|Platform] Node Environment key is required')
    return undefined
  }
  
  try {
    return process.env[environmentKey] || undefined
  } catch (error) {
    console.error(`[Package|Platform] Error accessing server environment variable: ${environmentKey}`, error)
    return undefined
  }
}

const clientEnv = (environmentKey: string) => {
  if (!environmentKey) {
    console.error('[Package|Platform] Browser Environment key is required')
    return undefined
  }

  if (!environmentKey.startsWith('NEXT_PUBLIC_')) {
    console.error(`[Package|Platform] Invalid environment key: ${environmentKey}. Client-side environment variables must start with NEXT_PUBLIC_`)
    return undefined
  }
  
  try {
    return (window[environmentKey as keyof typeof window] as string) || undefined
  } catch (error) {
    console.error(`[Package|Platform] Error accessing client environment variable: ${environmentKey}`, error)
    return undefined
  }
}

export const getEnv = <T extends string | undefined = any>(environmentKey: string): T | undefined => {
  if (!environmentKey) {
    console.error('[Package|Platform] Environment key is required')
    return undefined
  }

  const value = typeof window !== 'undefined' ? clientEnv(environmentKey) : serverEnv(environmentKey)
  return value as T | undefined
}
